import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {SynthesisService} from "../../synthesis.service";
import {FrCaIcsVtCustomGroupSummaryMapper} from "./fr.ca-ics-vt.custom-group-summary.mapper";

export class FrCaIcsVtSynthesisService extends SynthesisService {


    constructor(protected translationService: TranslationServiceInterface) {
        super(new FrCaIcsVtCustomGroupSummaryMapper(translationService), translationService);
    }

    protected async getServiceLabel(codeService: string, eForceRole: string) {
        return this.translationService.translate('LABEL_' + codeService + '_SERVICE_' + eForceRole, 'fr-FR');
    }
}


